<template>
  <b-col lg md="6" class="mb-4">
    <b-card :title="details.title">
      <template slot="header">
        <youtube
          v-if="showEmbedded"
          :video-id="video_id"
          player-width="100%"
          player-height="200"
          :player-vars="{ autoplay: 1 }"
        />
        <div v-else class="thumbnail" :style="thumbnailStyle" @click="showEmbedded=true">
          <b-icon-play-fill style="color: #f01614; height: 75px; width: 75px;" />
        </div>
      </template>
      <p v-html="details.description" />
    </b-card>
  </b-col>
</template>

<script lang="ts">
export default {
  props: {
    video: Object
  },
  data() {
    return {
      showEmbedded: false,
      thumbnailStyle: {
        height: "170px",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${this.video.snippet.thumbnails.standard.url})`
      }
    };
  },
  computed: {
    details() {
      return this.video.snippet;
    },
    video_id() {
      return this.details.resourceId.videoId;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  background: black;
  padding: 0;
  overflow: hidden;

  .thumbnail {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>